module.exports = __webpack_public_path__ + "static/media/transaction_preview.1a8d8a39.PNG";